import CardSystem from '../../Card/CardSystem';
import { UIEvent } from 'System/UI/BaseUISystem';
import {
    PlayAnimation,
} from 'System/Animation/AnimationHelper';
import { CardMatch } from 'System/Animation/Clip';
import AnimationClip from 'System/Animation/AnimationClip';
import BaseCard from 'Prototype/Level/Card/BaseCard';
import { delay } from 'Utility/Task/TaskQueue';
import { RenderSystemEvent } from 'System/Render/RenderSystem';
import Interactable from 'Component/Interactable';
import CardComponent from 'Component/Level/Card';

interface IReceiveJokerPreBoosterMeta {
    system: CardSystem;
}

export class ReceiveJokerPreBooster extends AnimationClip<
    IReceiveJokerPreBoosterMeta
> {
    public *execute(
        card: BaseCard,
        meta: IReceiveJokerPreBoosterMeta
    ): IterableIterator<number> {
        const cardComponent = card.getComponent(CardComponent);
        const interactable = card.getComponent(Interactable);
        interactable.enabled = false;
        const system = meta.system;

        system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);
        system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);
        system.animator.addChild(card);

        const match = new CardMatch(
            card,
            {
                system,
                cardScore: 0,
                coinsCollected: 0,
                playAudio: false,
                forceScale: false,
                target: system.cardStack.getCardTarget(card.id),
            },
            true
        );
        cardComponent.animating = true;
        cardComponent.skipStackAlign = true;

        yield* delay(250);

        system.cardStack.alignOnInsert(card.id, 800);

        yield* PlayAnimation(match);

        interactable.enabled = true;
        cardComponent.animating = false;
        cardComponent.skipStackAlign = false;
        system.cardStack.alignCard(card.id);
        system.scene.emit(UIEvent.RESTORE_INTERACTIVITY, true);
    }
}
